import type { CSSProperties } from "react";

export const directBossPageStyles = {
  shell: {
    margin: "0 1.25rem 1.5rem",
    maxWidth: "100%",
  } as CSSProperties,

  panel: {
    backgroundColor: "#ffffff",
    borderRadius: 16,
    border: "1px solid #e2e8f0",
    boxShadow: "0 4px 24px rgba(15, 23, 42, 0.06)",
    overflow: "hidden",
  } as CSSProperties,

  panelBody: {
    padding: "1.25rem 1.5rem 1.5rem",
  } as CSSProperties,

  tableWrapper: {
    borderRadius: 12,
    border: "1px solid #e2e8f0",
    overflow: "hidden",
    backgroundColor: "#ffffff",
  } as CSSProperties,

  tableScroll: {
    maxHeight: 560,
    overflowY: "auto",
    overflowX: "auto",
  } as CSSProperties,

  table: {
    width: "100%",
    marginBottom: 0,
    borderCollapse: "collapse",
  } as CSSProperties,

  thead: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: "#f8fafc",
  } as CSSProperties,

  th: {
    padding: "14px 16px",
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#64748b",
    borderBottom: "1px solid #e2e8f0",
    whiteSpace: "nowrap",
    cursor: "pointer",
    userSelect: "none",
  } as CSSProperties,

  thStatic: {
    padding: "14px 16px",
    fontSize: 12,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#64748b",
    borderBottom: "1px solid #e2e8f0",
    whiteSpace: "nowrap",
  } as CSSProperties,

  td: {
    padding: "14px 16px",
    verticalAlign: "middle",
    borderBottom: "1px solid #f1f5f9",
    fontSize: 14,
    color: "#334155",
  } as CSSProperties,

  trHover: {
    transition: "background-color 0.15s ease",
  } as CSSProperties,

  bossCell: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    minWidth: 200,
  } as CSSProperties,

  bossName: {
    margin: 0,
    fontSize: 16,
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.3,
  } as CSSProperties,

  bossRole: {
    margin: "2px 0 0",
    fontSize: 13,
    color: "#64748b",
  } as CSSProperties,

  metaBlock: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    flex: "1 1 160px",
    minWidth: 140,
  } as CSSProperties,

  metaLabel: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "#94a3b8",
  } as CSSProperties,

  metaValue: {
    fontSize: 14,
    color: "#334155",
    lineHeight: 1.4,
  } as CSSProperties,

  actions: {
    display: "flex",
    gap: 8,
    flexShrink: 0,
    marginLeft: "auto",
  } as CSSProperties,

  actionBtn: (variant: "edit" | "delete"): CSSProperties => ({
    width: 38,
    height: 38,
    padding: 0,
    borderRadius: 10,
    border: `1px solid ${variant === "edit" ? "#fcd34d" : "#fca5a5"}`,
    backgroundColor: variant === "edit" ? "#fffbeb" : "#fef2f2",
    color: variant === "edit" ? "#b45309" : "#b91c1c",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  }),

  emptyState: {
    textAlign: "center",
    padding: "4rem 1.5rem",
    border: "1px dashed #cbd5e1",
    borderRadius: 14,
    backgroundColor: "#f8fafc",
  } as CSSProperties,
};

export const DIRECT_BOSS_PAGE_KEYFRAMES = `
  @keyframes bossAvatarShimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }
`;
